import { ReactNode } from "react";
import { ThemeProvider } from "styled-components";
import { themeConfig } from "config/theme/config";

const ThemeProvide = ({ children }: { children: ReactNode }): JSX.Element => {

  return (
    <ThemeProvider theme={themeConfig}>{children}</ThemeProvider>
  );
};

export default ThemeProvide;